/**
 * Indicates status of event which will then influence it's styling
 */
export default Object.freeze({
  UNSET: 'unset',
  OK: 'ok',
  REQUIRES_ACTION: 'requires_action',
})
